import React, { useEffect } from 'react'
import { getToken } from 'Helper'
import Layout from 'includes/Layout'
// import { useSelector } from 'react-redux'
import { Navigate, useNavigate } from 'react-router-dom'
import useSWR from 'swr'
// import Loader from './Loader'

let timeout

export default function ProtectedRoute({ layout=true, component: Component, ...info }) {
  const token = getToken()
  const { data: user } = useSWR('auth/me')

  // const { loading } = useSelector(state => state.misc)

  const navigate = useNavigate()
  useEffect(() => {
    if (!user) {
      timeout = setTimeout(() => {
        // navigate('/login')

      }, 3000);
      // return <>Loading...</>
    }

    return () => {
      clearTimeout(timeout)
    }

  }, [navigate, user])
  return (
    layout ? (
      <Layout>
        <>
          {
            token ? <Component /> : <Navigate to='/login' />
          }
        </>
      </Layout>
    ) : (
      <>
        {
          token ? <Component /> : <Navigate to='/login' />
        }
      </>
    )
  )
}



